import React, { useEffect, useRef } from 'react';
import Input from '../formElements/Input';
import Icon from '../Icon';
import ChipInput from '../formElements/ChipInput';
import { FILTER_INPUT_SEPARATOR } from '../../constants';
import localeLookup from '../../config/locale';

const ModalFilter = ({
  placeholder,
  onChange,
  value,
  showButton,
  onButtonClick,
  buttonIcon,
  buttonText,
  termsResultCount,
  useChipInput = false,
  showClearButton = false,
}) => {
  const inputRef = useRef(null);
  const showChipInput = useChipInput && value.includes(FILTER_INPUT_SEPARATOR);
  const getShowRightButton = () => {
    if (!showButton) return false;
    if (useChipInput) {
      return !showChipInput;
    }
    return true;
  };

  const showRightButton = getShowRightButton();

  const onChangeInput = (e) => {
    // Prevent creating empty chips when user types only the separator
    if (useChipInput && e.target.value.trim() === FILTER_INPUT_SEPARATOR) {
      return;
    }
    onChange(e);
  };

  const onChangeChipInput = (inputValue) => {
    // Prevent creating empty chips when user types only the separator
    if (inputValue.trim() === FILTER_INPUT_SEPARATOR) {
      return;
    }
    // Only update the part of the value being edited, which is the part after the last separator
    const lastSeparatorIndex = value.lastIndexOf(FILTER_INPUT_SEPARATOR);
    const baseValue =
      lastSeparatorIndex !== -1 ? value.slice(0, lastSeparatorIndex + 1) : '';
    const newValue = `${baseValue}${inputValue}`;
    onChange({ target: { value: newValue } });
  };

  const removeEntryFromFilterValue = (index) => {
    const entries = value
      .split(FILTER_INPUT_SEPARATOR)
      .map((entry) => entry.trim());
    entries.splice(index, 1);
    const newValue = entries.join(FILTER_INPUT_SEPARATOR + ' ');
    onChange({ target: { value: newValue } });
  };

  const onEnterPress = (e) => {
    if (useChipInput && value.trim() !== '') {
      e.preventDefault();
      onChange({ target: { value: value + FILTER_INPUT_SEPARATOR + ' ' } });
    }
  };

  const onClear = () => {
    onChange({ target: { value: '' } });
  };

  const onPaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text');
    if (
      pastedData &&
      (pastedData.includes('\n') ||
        pastedData.includes('\t') ||
        pastedData.includes(FILTER_INPUT_SEPARATOR))
    ) {
      // Replace newlines with FILTER_INPUT_SEPARATOR
      const formattedData = pastedData
        .split(/[\n\t]/)
        .map((item) => item.trim())
        .filter((item) => item)
        .join(FILTER_INPUT_SEPARATOR + ' ');
      onChange({ target: { value: `${formattedData};` } });
    } else {
      onChange({ target: { value: pastedData } });
    }
  };

  const getChips = () => {
    const chips = value
      .split(FILTER_INPUT_SEPARATOR)
      .slice(0, -1)
      .map((item) => {
        const resultCount = termsResultCount[item.trim()] || 0;
        return {
          value: item.trim(),
          label: `${item.trim()} (${resultCount})`,
          count: resultCount,
          color:
            resultCount === 0 ? 'red' : resultCount === 1 ? 'green' : 'yellow',
          tooltip: `${
            resultCount === 1
              ? localeLookup('translations.{0} match', [resultCount])
              : localeLookup('translations.{0} matches', [resultCount])
          }`,
        };
      });
    return chips;
  };

  return (
    <div className="modal-content__filter">
      {showChipInput ? (
        <ChipInput
          chips={getChips()}
          clearOnValue={FILTER_INPUT_SEPARATOR}
          innerRef={inputRef}
          onChangeInput={onChangeChipInput}
          onClear={onClear}
          onRemoveChip={removeEntryFromFilterValue}
          placeholder={placeholder}
          value={value}
        ></ChipInput>
      ) : (
        <Input
          autoFocus
          className="modal-content__filter-input"
          infoTooltip={
            useChipInput
              ? localeLookup(
                  'translations.Use semicolon (;) or Enter to search for multiple terms. You can also paste from a spreadsheet.'
                )
              : null
          }
          innerRef={inputRef}
          onChange={onChangeInput}
          onEnterPress={onEnterPress}
          onPaste={onPaste}
          placeholder={placeholder}
          showClearButton={showClearButton}
          type="text"
          value={value}
        />
      )}
      {showRightButton && (
        <button
          className="ui-btn ui-btn-darkui modal-content__filter-button"
          onClick={onButtonClick}
          type="button"
        >
          {buttonIcon && <Icon kind={buttonIcon} />}
          {buttonText}
        </button>
      )}
    </div>
  );
};

export default ModalFilter;
